module.exports = __webpack_public_path__ + "static/media/Slide99.b8b6cc9c.JPG";